import { render } from "./ReportingMethod.vue?vue&type=template&id=2df960c6"
import script from "./ReportingMethod.vue?vue&type=script&lang=js"
export * from "./ReportingMethod.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.7\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__